import React, {useState, useEffect} from 'react'
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Vector from '../images/new_uiuxlogo1.png';
import Preview from './Preview';
import Footers from './Footers';
import { Flex, Spin } from 'antd';

const Header = () => {
  return (
    <header className="fixed top-0 w-full bg-white border-b z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center">
            <img src={Vector} alt="UI/UX Jobs Hub" className="h-8 w-auto" style={{  
                WebkitFilter: 'brightness(0)',
               }} />
          </Link>
          
          <nav className="hidden md:flex space-x-8">
            <Link to="/post-job" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium">
              Post a Job
            </Link>
            <Link to="/browse-jobs" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium">
              Browse Jobs
            </Link>
            <Link to="/for-employers" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium">
              For Employers
            </Link>
          </nav>

          <div className="flex items-center space-x-4">
            <button className="hidden md:inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
              Sign In
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

const DisplayContent = () => {
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSalary, setSelectedSalary] = useState('');
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedOptiontype, setSelectedOptiontype] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedOptionduration, setSelectedOptionduration] = useState('');
    const [value, setValue] = useState('');
    const [title, settitle] = useState('');
    const [applylink, setapplylink] = useState('');
    const [city, setCity] = useState('');
    const [companyName, setcompanyName] = useState('');
    const [posterEmail, setposterEmail] = useState('');
    const [companywebsiteLink, setcompanywebsiteLink] = useState('');
    const [allOtherdata, setAllOtherdata] = useState({});
    const [display_url, setDisplayUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [isRendered, setIsRendered] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const jobid = queryParams.get('id');
   // console.log('job-id',jobid);

    useEffect(()=>{
        window.scrollTo(0, 0);
        if(jobid){
            getAllJobInfoById();
        }
        
      },[]);
    const getAllJobInfoById = () => {
      setLoading(true);
        fetch(`${process.env.REACT_APP_BACKEND_URL}/v1/api/get-job/${jobid}`, {
          method:"GET",
          headers:{
            "Content-Type":"application/json"
          },
          mode:"cors",
        })
        .then((res) => {
          if (res && res.ok){
            return res.json(); 
           
          }else {
            throw new Error("Network response was not ok.");
          }
        }).then((data) => {
         // console.log('inside res');
          //console.log('data:', data);
         // console.log('message:', data.data.results[0],data.data.results[0].companywebsiteLink);
         // setList(data.data); // Set the list using the correct data property
         setSelectedCategory(data.data.results[0].selectedCategory);
         setSelectedSalary(data.data.results[0].selectedSalary);
         setSelectedCountry(data.data.results[0].selectedCountry);
         setSelectedOptiontype(data.data.results[0].selectedOptiontype);
         setSelectedOptionduration(data.data.results[0].selectedOptionduration);
         setValue(data.data.results[0].value);
         settitle(data.data.results[0].title);
         setapplylink(data.data.results[0].applylink);
         setCity(data.data.results[0].city);
         setcompanyName(data.data.results[0].companyName);
         setposterEmail(data.data.results[0].posterEmail);
         setcompanywebsiteLink(data.data.results[0].companywebsiteLink);
         setDisplayUrl(data.data.results[0].display_url)
         const otherdata = {
          clicked_apply:data.data.results[0].clicked_apply,
          clicked_viewed:data.data.results[0].viewed,
          postedOn:data.data.results[0].created_at,
         }
         setAllOtherdata(otherdata)
         setIsRendered(true);
          setLoading(false);
        })
        .catch(e => {
          console.log(e.error);
          //setList([...JobCardData]);
        })
      }

  return (
    
       <div style={{backgroundColor:'#f5f5f5'}}>
       <div className=' h-auto'>
            {/* banner is done */}

                <div className=' h-fit  mx-auto flex    flex-row  justify-content-start  bg-white  shadow-lg backdrop-filter backdrop-blur-lg ' style={{ top:'0', width:'100%'}}>
                <div className='flex md:flex-row flex-col md:justify-between justify-around w-11/12 h-16    text-2xl font-bold mx-10 mt-4'>
                <Link to ="/">
                {/* <img src={logo} className='w-28 border border-black' alt='logos' /> */}
                <img class="ml-5 w-auto   h-9" src={Vector} alt="" style={{  
                WebkitFilter: 'brightness(0) ',
               }} />
                </Link>
                    <ul className='text-sm flex flex-row text-gray-600  mt-2'>
                        <Link to ="/terms"><li className='mx-3'>Terms</li></Link>
                        <Link to ="/privacy-policy"><li className='mx-3'>Privacy</li></Link>
                        <Link to ="/contact-us"><li className='mx-3'>Get in touch</li></Link>
                    </ul>
                </div>
                    {/* <BannerHome/> */}
                    {/* <div className='flex flex-wrap lg:w-6/12 h-fit border lg:text-5xl text-2xl font-bold mt-5 mx-auto'>
                    Discover Top Design Talent: Find Exceptional UI Designers and UX Researchers. Start Your Search Today!
                    </div> */}
                </div>

                <Spin size="large" spinning={loading} fullscreen />
          <Preview selectedCategory={selectedCategory}
             jobid={jobid}
                selectedSalary={selectedSalary}
                selectedCountry={selectedCountry}
                selectedOptiontype={selectedOptiontype}
                selectedFile={selectedFile}
                selectedOptionduration={selectedOptionduration}
                value={value}
                title={title}
                applylink={applylink}
                city={city}
                companyName={companyName}
                posterEmail={posterEmail}
                companywebsiteLink={companywebsiteLink}
                otherdata={allOtherdata}
                display_url={display_url}
                isRendered={isRendered}
                setIsRendered={setIsRendered}
                />
                
                </div>

        <Footers/>
        </div>        
    
  )
}

export default DisplayContent;